import ExpertiseSelect from '@components/common/expertise-select';
import { showNotification } from '@helpers/notification-helper';
import { PlusOutlined } from '@icon';
import { createExpertise } from '@services/external/user.api';
import { Button, DateField, Drawer, Form } from '@ui';
import moment from 'moment';
import React from 'react';
import { useTheme } from 'styled-components';
import { initialValues, validationSchema } from './specialization-form.schema';

const gte = (e: any) => e;

interface SpecializationFormProps {
  visible?: boolean;
  onClose?: () => void;
  afterSubmit?: () => void;
}

const SpecializationForm: React.FunctionComponent<SpecializationFormProps> = ({
  afterSubmit,
  onClose,
  visible,
}) => {
  const theme = useTheme();
  const [, formOptions] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit: async (v) => {
      try {
        await createExpertise(v.expertiseCode?.value!, moment(v.from!).format('YYYY-MM-DD'));
        showNotification({
          title: 'Špecializácia pridaná',
          copy: '',
          type: 'SUCCESS',
        });
        afterSubmit?.();
      } catch (error) {
        showNotification({
          title: 'Niečo sa pokazilo',
          copy: '',
          type: 'ERROR',
        });
      }
    },
  });

  return (
    <Drawer visible={visible} onClose={onClose} destroyOnClose title="Pridanie špecializácie">
      <Form {...formOptions}>
        <Form.Field name="expertiseCode" label="Expertíza" getValueFromEvent={gte} required>
          <ExpertiseSelect />
        </Form.Field>
        <Form.Field
          name="from"
          label="Prax od"
          getValueFromEvent={gte}
          required
          caption="Ak si nepamätáte presný dátum, zadajte začiatok roka praxe"
        >
          <DateField />
        </Form.Field>
        <Form.Custom>
          {(f) => (
            <Button
              type="submit"
              Icon={PlusOutlined}
              style={{ marginTop: theme.spacings.component.M }}
              loading={f.isSubmitting}
            >
              Pridať špecializáciu
            </Button>
          )}
        </Form.Custom>
      </Form>
    </Drawer>
  );
};

export default SpecializationForm;
